import { render, staticRenderFns } from "./AvatarStatusCompromissoEntrega.vue?vue&type=template&id=79a808a3&"
import script from "./AvatarStatusCompromissoEntrega.vue?vue&type=script&lang=js&"
export * from "./AvatarStatusCompromissoEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports